module.exports = __webpack_public_path__ + "img/ELMS_Logo.876b3e35.png";